import { LANDSCAPE_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/landscapeBackdrops';
import { ATMOSPHERE_PALETTE as P } from '../palette';
import { frozenBiome } from '../biomeArchetypes';

/** Frostspire Peaks — high ALPINE snow-capped mountains: a cold pale-blue sky, thin high cloud
 *  bands, a wan high sun, fine snow glints adrift, cold sun shafts, a breathing cold bloom bed, a
 *  crisp light bed, thin wind-blown snow, a faint snow-level glint, and TALL multi-plane jagged
 *  snow-capped peaks that rise high for altitude. Crisp, vast, VERTICAL — DISTINCT from arctic's
 *  flat ice/glacier: this is altitude + soaring peaks, not a frozen plain. Contrast kept (cold
 *  'normal' grade, no pale wash). */
export const FROSTSPIRE = frozenBiome({
  id: 'frostspire',
  sky: { from: 0x5a86bb, to: 0xbfd8ec },
  celestial: { atX: 0.68, atY: 0.13, color: 0xeaf4ff, haloColor: 0xcfe6ff, size: 80, haloScale: 2.8, coreAlpha: 0.78, haloAlpha: 0.16 },
  cloudBands: { count: 5, color: 0xeaf4ff, sizeMin: 360, sizeMax: 640, alphaMin: 0.05, alphaMax: 0.12, driftPxPerSec: 5, bandYMin: 0.06, bandYMax: 0.28 },
  motes: { colors: [P.ice, P.frostCore, 0xeaf6ff] },
  rays: { color: 0xdcecff },
  glow: {
    blobs: [
      { color: 0xeaf4ff, atX: 0.68, atY: 0.12, size: 420, alpha: 0.08 },
      { color: P.frostCore, atX: 0.5, atY: 0.97, size: 600, alpha: 0.07 },
    ],
    breathe: { periodMs: 7000, min: 0.85, max: 1.2 },
  },
  lightField: { palette: [P.frostCore, P.ice, P.crystal] },
  weather: { mode: 'fall', color: 0xeaf6ff, colorEnd: 0xbfe0f4, gust: { periodMs: 8000, min: 0.5, max: 1.45, phase: 0.3 } },
  flicker: { color: 0xdfeeff },
  parallax: [
    { svg: LANDSCAPE_BACKDROPS.mountains.far, shape: 'peaks', color: 0x9fbcd8, speed: 0.04, height: 520, alpha: 0.7, detail: 0.8, sway: { ampPx: 10, periodMs: 30000 } },
    { svg: LANDSCAPE_BACKDROPS.mountains.mid, shape: 'spires', color: 0x7a9cc0, speed: 0.10, height: 380, alpha: 0.84, detail: 1.1 },
    { svg: LANDSCAPE_BACKDROPS.mountains.near, shape: 'peaks', color: 0x546f93, speed: 0.19, height: 240, alpha: 0.94, detail: 1 },
  ],
  closer: {
    vignette: { color: 0x2a3a4e, edgeAlpha: 0.24, washColor: 0xbfe0f4, washAlpha: 0.04 },
    grade: { top: 0xdbeeff, bottom: 0x7fa8cc, strength: 0.1, blend: 'normal' },
  },
});
